import { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types"; // import PropTypes
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  let [user, setUser] = useState(() =>
    localStorage.getItem("authTokens") ? jwtDecode(localStorage.getItem("authTokens")) : null
  );
  let [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens") ? JSON.parse(localStorage.getItem("authTokens")) : null
  );
  let [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  let loginUser = async (e) => {
    e.preventDefault();
    const response = await fetch("https://teleback.info/api/token/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: e.target.username.value,
        password: e.target.password.value,
      }),
    });

    let data = await response.json();

    if (data && response.ok) {
      localStorage.setItem("authTokens", JSON.stringify(data));

      setAuthTokens(data);
      setUser(jwtDecode(data.access));
      navigate("/messages");
    } else {
      alert("Something went wrong while logging in the user!");
    }
  };

  const updateToken = async () => {
    const response = await fetch("https://teleback.info/api/token/refresh/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh: authTokens?.refresh }),
    });

    const data = await response.json();
    if (response.status === 401) {
      signOut();
      navigate("/sign-out");
    }
    if (response.status === 200) {
      setAuthTokens(data);
      setUser(jwtDecode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
    }

    if (loading) {
      setLoading(false);
    }
  };

  const signOut = () => {
    localStorage.removeItem("authTokens");
    setAuthTokens(null);
    setUser(null);
    navigate("/login");
  };

  let contextData = {
    user: user,
    authTokens: authTokens,
    loginUser: loginUser,
    signOut: signOut,
  };

  useEffect(() => {
    if (loading) {
      updateToken();
    }

    const REFRESH_INTERVAL = 1000 * 60 * 4; // 4 minutes
    let interval = setInterval(() => {
      if (authTokens) {
        updateToken();
      }
    }, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [authTokens, loading]);

  return <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>;
};

// Define propTypes to validate props
AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
